import {
  Box,
  Button,
  Heading,
  Text,
  VStack,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FaEnvelope } from 'react-icons/fa';
import { Section } from '../layout/Section';

const MotionBox = motion(Box);

export const Contact = () => {
  const cardBg = useColorModeValue('brand.500', 'brand.600');

  return (
    <Section id="contact">
      <MotionBox
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <Box
          bg={cardBg}
          borderRadius="2xl"
          p={{ base: 8, md: 12 }}
          textAlign="center"
          color="white"
        >
          <VStack spacing={6}>
            <Icon as={FaEnvelope} w={12} h={12} opacity={0.9} />
            <Heading as="h2" size="xl">
              Let's Build Something Great
            </Heading>
            <Text fontSize="lg" maxW="2xl" opacity={0.9}>
              Have a project in mind? We'd love to hear about it. Whether you
              need a full-scale platform or a focused solution, we're here to
              help turn your vision into reality.
            </Text>
            <Button
              as="a"
              href="mailto:hello@silentech.gr"
              size="lg"
              colorScheme="whiteAlpha"
              bg="white"
              color="brand.600"
              _hover={{
                bg: 'gray.100',
              }}
              leftIcon={<FaEnvelope />}
            >
              hello@silentech.gr
            </Button>
          </VStack>
        </Box>
      </MotionBox>
    </Section>
  );
};
